import {z} from 'zod';

export const PermissionMatrixEntrySchema = z.union([
	z.literal(1),
	z.literal(0),
]);

/** `['read', 'download', 'add', 'modify', 'delete', 'all']` (represented by 1s and 0s) */
export const PermissionMatrixSchema = z.tuple([
	/** read */
	PermissionMatrixEntrySchema,
	/** download */
	PermissionMatrixEntrySchema,
	/** add */
	PermissionMatrixEntrySchema,
	/** modify */
	PermissionMatrixEntrySchema,
	/** delete */
	PermissionMatrixEntrySchema,
	/** all */
	PermissionMatrixEntrySchema,
]);

export type IPermissionMatrixEntry = z.infer<
	typeof PermissionMatrixEntrySchema
>;

/** `['read', 'download', 'add', 'modify', 'delete', 'all']` (represented by 1s and 0s) */
export type IPermissionMatrix = z.infer<typeof PermissionMatrixSchema>;
